export default __webpack_public_path__ + "static/media/location.ce518eb5.svg";